import base from '@primeuix/themes/aura/base';
import autocomplete from '@primeuix/themes/aura/autocomplete';
import badge from '@primeuix/themes/aura/badge';
import button from '@primeuix/themes/aura/button';
import chip from '@primeuix/themes/aura/chip';
import dialog from '@primeuix/themes/aura/dialog';
import inputnumber from '@primeuix/themes/aura/inputnumber';
import inputtext from '@primeuix/themes/aura/inputtext';
import password from '@primeuix/themes/aura/password';
import popover from '@primeuix/themes/aura/popover';
import ripple from '@primeuix/themes/aura/ripple';
import speeddial from '@primeuix/themes/aura/speeddial';
import toast from '@primeuix/themes/aura/toast';
import tooltip from '@primeuix/themes/aura/tooltip';
import virtualscroller from '@primeuix/themes/aura/virtualscroller';

// Include internal dependencies too: e.g. AutoComplete uses Chip and VirtualScroller.
// When adding PrimeVue components, include their Aura presets here.
export default {
  ...base,
  components: {
    autocomplete,
    badge,
    button,
    chip,
    dialog,
    inputnumber,
    inputtext,
    password,
    popover,
    ripple,
    speeddial,
    toast,
    tooltip,
    virtualscroller,
  },
};
